const request = require('superagent');

const MunicipalityAPI = {
    getMunicipalities: () => request
        .get(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v1/municipality/get_all_municipalities`)
        .set('Accept', 'application/json')
        .send().then(
            (response) => Object.keys(response.body).reduce((acc, current) => [...acc, ...response.body[current]], []),
        ),
};

export default MunicipalityAPI;



/** WEBPACK FOOTER **
 ** ./src/apis/municipality.js
 **/